<template>
  <q-dialog
    v-model="shown"
    :maximized="$q.screen.lt.md"
  >
    <q-card style="min-width: 50%;">
      <q-card-section class="row items-center q-mx-xs">
        <div
          class="text-h6"
        >
          Invoice ({{ order.id }})
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <!-- eslint-disable vue/no-v-html -->
      <!-- v-html produced by backend template -->
      <q-card-section class="row justify-center">
        <div v-html="order.invoiceHtml" />
      </q-card-section>
      <!-- eslint-enable vue/no-v-html -->
      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          v-close-popup
          label="Done"
          color="primary"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'InvoiceDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      printing: false,
      id: null
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      if (this.shown) {
        this.$trackPage(this, { orderId: this.id })
      }
    }
  },
  methods: {
    show (id) {
      this.id = id
      this.shown = true
    }
  },
  models: {
    order: {
      fields: ['id', 'invoiceHtml'],
      variables () {
        return {
          id: this.id
        }
      },
      force: true
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
